import { useState } from "react";
import ApiClient from "../../../api";
import { useFlashMessage } from "../../../hooks/useFlashMessage";

export const useDownloadDrillTemplate = () => {
  const { showErrorMessage } = useFlashMessage();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadTemplate = async () => {
    if (isDownloading) {
      return;
    }
    setIsDownloading(true);
    try {
      const url =
        "/api/v1/sections/multi_section_batches/templates/upload_drill.csv";
      const response = await ApiClient.get(url);
      if (!response.ok) {
        throw new Error();
      }
      const blob = await response.blob();

      const blobUrl = URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");

      downloadLink.style.display = "none";
      downloadLink.href = blobUrl;
      downloadLink.download = "upload_drill_template.csv";

      document.body.appendChild(downloadLink);
      downloadLink.click();

      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(blobUrl);
    } catch (_) {
      showErrorMessage("ダウンロードできませんでした");
    } finally {
      setIsDownloading(false);
    }
  };

  return { downloadTemplate, isDownloading };
};
